import React from "react";
import { toElementProps } from "../../Element";
import useLoremIpsum from "../technical/useLoremIpsum.jsx";

export function LogotypeStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .logotype:not(.mobile)": {
            display: "block",

            display: "grid",
            gridTemplateColumns: "max-content max-content",
            gridGap: "8px",
            alignItems: "center",

            fontSize: "inherit",
            color: "inherit",
            textDecoration: "none !important",

            "& img": {
                height: "40px",
            },

            [MobileBreakpoint]: {
                maxWidth: "300px",
                "& span": {
                    maxWidth: "300px",
                    fontSize: "medium",
                },
            },
        },
        "& .logotype.mobile": {
            display: "grid",
            gridTemplateColumns: "max-content max-content",
            gridGap: "8px",
            alignItems: "center",

            color: "inherit",
            textDecoration: "none !important",

            fontSize: "25px !important",
            padding: "20px 16px !important",
            pointerEvents: "none",

            "& img": {
                height: "40px",
            },
            "& span": {
                maxWidth: "300px",
            },
        },
    };
}

export default function Logotype(props) {
    const LI = useLoremIpsum();

    const { BusinessName, ProductName, ProductPicture, ProductType } = props.variables;
    let title;

    if (props.useTitle) {
        if (ProductType === "ecommerce") {
            title = BusinessName;
        } else {
            title = ProductName || LI.Logotype;
        }
    }

    // TODO: The solution for the favicon will be resolve in the future.
    // const favicon = (ProductPicture?.mobile ?? ProductPicture?.desktop)?.file?.dataUrlBase64;
    const CNLogotype = ["logotype"];
    props.mobile && CNLogotype.push("mobile");

    const elProps = toElementProps(props, { className: CNLogotype });
    return (
        <a {...elProps} href="/">
            {/* {favicon && <img src={favicon} alt="Logotype" />} */}
            {title && <span>{title}</span>}
        </a>
    );
}
